import { IPayrollSend } from 'src/types/payroll';
import { PayrollFormData } from 'src/screens/General/screens/Payrolls/components/PayrollForm';
import { changeToZeroMoment } from '../timeHelpers';

const groupPayroll = (dataForm: Partial<PayrollFormData>): Partial<IPayrollSend> => {
    const { dateFrom, dateTo, ...restData } = dataForm;
    const dataSend: Partial<IPayrollSend> = { ...restData };
    const arrProviders = Object.keys(restData.providers).map((key) => {
        return +key;
    });

    if (dateFrom) {
        dataSend.dateFrom = changeToZeroMoment(dateFrom, 'YYYY-MM-DD');
    }
    if (dateTo) {
        dataSend.dateTo = changeToZeroMoment(dateTo, 'YYYY-MM-DD');
    }

    delete restData.providers;

    return {
        ...dataSend,
        providers: arrProviders,
    };
};
export { groupPayroll };
